import api from '../utils/api';

export async function registerUser({ name, email, password, workspaceName }) {
  const { data } = await api.post('/users/register', {
    name,
    email,
    password,
    workspace_name: workspaceName || name,
  });
  return data;
}

export async function loginUser({ email, password }) {
  const { data } = await api.post('/users/login', { email, password });
  return data;
}

export async function fetchCurrentUser() {
  const { data } = await api.get('/users/me');
  return data;
}

export async function fetchCurrentAccount() {
  const { data } = await api.get('/accounts/me');
  return data;
}

export async function createWorkspace({ name }) {
  const { data } = await api.post('/accounts/workspaces', { name });
  return data;
}

export async function fetchAccountMembers(accountId) {
  const { data } = await api.get(`/accounts/${accountId}/members`);
  return data;
}

export async function createAccountInvitation(accountId, payload) {
  const { data } = await api.post(`/accounts/${accountId}/invitations`, payload);
  return data;
}

export async function fetchAccountInvitations(accountId) {
  const { data } = await api.get(`/accounts/${accountId}/invitations`);
  return data;
}

export async function cancelAccountInvitation(accountId, invitationId) {
  await api.delete(`/accounts/${accountId}/invitations/${invitationId}`);
}

export async function fetchInvitation(token) {
  const { data } = await api.get(`/invitations/${token}`);
  return data;
}

export async function acceptInvitation(token, payload = {}) {
  const { data } = await api.post(`/invitations/${token}/accept`, payload);
  return data;
}

export async function removeAccountMember(accountId, userId) {
  await api.delete(`/accounts/${accountId}/members/${userId}`);
}

// Deprecated aliases
export async function createAccount(params) {
  return registerUser(params);
}

export async function loginAccount(params) {
  return loginUser(params);
}
